import { CxEvent } from '@spartacus/core';

export class Ga4GgPurchaseEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    transaction_id?: string;
    value?: number;
    shipping?: number;
    tax?: number;
    currency?: string;
    coupon?: string;
    items?: {
      item_id?: string;
      item_name?: string;
      discount?: string;
      coupon?: string;
      price?: number;
      quantity?: number;
    }[];
  } | null;
}
